var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11 1a8.261 8.261 0 0 0-8.25 8.25c0 5.923 7.686 13.34 8.013 13.654a.34.34 0 0 0 .474 0c.327-.313 8.013-7.731 8.013-13.654A8.26 8.26 0 0 0 11 1Zm0 12.031a3.781 3.781 0 1 1 0-7.562 3.781 3.781 0 0 1 0 7.562Z",
  fill: "#697077"
})));
export default SvgPin;